import {DatePipe} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core'
import {FormControl, ReactiveFormsModule} from '@angular/forms'
import {MatIconButton} from '@angular/material/button'
import {MatCard, MatCardContent} from '@angular/material/card'
import {MatDialog} from '@angular/material/dialog'
import {MatFormField, MatLabel} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {MatSort, MatSortHeader} from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'
import {MatTooltip} from '@angular/material/tooltip'
import {BaseTable} from '@sparbanken-syd/sparbanken-syd-theme'
import {startWith} from 'rxjs/operators'
import {AdminService, RequestListItem} from '../../services/admin.service'
import {DocDialogComponent} from '../doc-dialog/doc-dialog.component'


export interface DisplayListItem {
  personNummer: string
  sub: string
  consumed: string
  timeStamp: number
  ref: string
  documentation: string
}

@Component({
  selector: 'spb-request-list-item',
  templateUrl: './request-list-item.component.html',
  styleUrls: ['./request-list-item.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatIconButton,
    MatIcon,
    MatTooltip,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatNoDataRow,
    MatCard,
    MatCardContent,
    DatePipe
  ]
})
export class RequestListItemComponent extends BaseTable<DisplayListItem> implements OnInit {
  public filterControl = new FormControl<string>('', {nonNullable: true})

  private readonly adminService = inject(AdminService)

  private readonly dialog = inject(MatDialog)

  constructor() {
    super()
    this.columns.set(
      ['personNummer', 'sub', 'consumed', 'timeStamp', 'documentation']
    )
  }

  public ngOnInit(): void {
    this.filterControl.valueChanges.pipe(
      startWith('')
    ).subscribe(value =>
      this.items.filter = value.trim().toLowerCase().replace('-', '')
    )

    this.adminService.getRequests()
      .subscribe(requests => {
        const displayRequests = requests
          .map((server: RequestListItem): DisplayListItem => {
            server.consumed = server.consumed || []
            const consumed = server.consumed[0] || {}
            return {
              personNummer: server.personNummer,
              sub: server.sub,
              consumed: consumed.sub,
              timeStamp: server.timeStamp,
              ref: server.ref,
              documentation: server.documentation
            }
          })

        this.items.data = displayRequests
          .toSorted((a, b) =>
            b.timeStamp - a.timeStamp
          )
      })
  }

  public openDialog(doc: string) {
    this.dialog.open(DocDialogComponent, {data: doc})
  }
}